import {
  Directive,
  Input,
  TemplateRef,
  OnInit,
  ElementRef,
  HostListener,
  ViewContainerRef,
} from '@angular/core';
import {
  ComponentType,
  ComponentPortal,
  TemplatePortal,
} from '@angular/cdk/portal';
import {
  OverlayRef,
  Overlay,
  OverlayPositionBuilder,
} from '@angular/cdk/overlay';

@Directive({
  selector: '[appTooltip]',
  standalone: true,
})
export class TooltipDirective implements OnInit {
  @Input('appTooltip') tooltipContent: TemplateRef<any> | ComponentType<any>;

  /** Overlay that simulates being a tooltip */
  private _overlayRef: OverlayRef;

  constructor(
    private overlay: Overlay,
    private overlayPositionBuilder: OverlayPositionBuilder,
    private elementRef: ElementRef,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit(): void {
    // If the content to be displayed is received
    if (this.tooltipContent) {
      // Positioning configuration for the tooltip is created
      const position = this.overlayPositionBuilder
        .flexibleConnectedTo(this.elementRef)
        .withPositions([
          {
            originX: 'center',
            originY: 'bottom',
            overlayX: 'center',
            overlayY: 'top',
            offsetX: 0,
            offsetY: 8,
          },
          {
            originX: 'center',
            originY: 'top',
            overlayX: 'center',
            overlayY: 'bottom',
            offsetX: 0,
            offsetY: -8,
          },
        ]);

      // The overlay is created and its reference is saved
      this._overlayRef = this.overlay.create({
        // Settings for overlay position
        positionStrategy: position,
        // Overlay behavior when scrolling and displaying
        scrollStrategy: this.overlay.scrollStrategies.close(),
        // Class to style the overlay
        panelClass: 'custom-tooltip',
      });
    }
    // An error is displayed if the policy does not receive content to display
    else {
      console.error(
        '[ERROR] La directiva tiene que recibir el contenido a mostrar...'
      );
    }
  }

  @HostListener('mouseenter')
  private _show(): void {
    // If there is an overlay, it is linked to the content
    if (this._overlayRef) {
      let containerPortal: TemplatePortal<any> | ComponentPortal<any>;

      //We create a TemplatePortal if what received the directive was a Template
      if (this.tooltipContent instanceof TemplateRef) {
        containerPortal = new TemplatePortal(
          this.tooltipContent,
          this.viewContainerRef
        );
      }
      // Otherwise we create a ComponentPortal
      else {
        containerPortal = new ComponentPortal(
          this.tooltipContent,
          this.viewContainerRef
        );
      }

      // We link the portal with the overlay created when starting the directive
      this._overlayRef.attach(containerPortal);
    }
  }

  @HostListener('mouseout')
  private _hide(): void {
    // If there is an overlay, it is detached from the content
    if (this._overlayRef) {
      this._overlayRef.detach();
    }
  }
}
